module.exports = __webpack_public_path__ + "img/dgitem5.a7b183cf.png";